module.exports =

  printLetter: (className) ->
    printContent = document.getElementsByClassName(className)[0]?.contentWindow
    printContent?.focus()
    printContent?.print()
